module.exports = __webpack_public_path__ + "static/media/Comfortaa-Bold.d28990ee.eot";